/* Chrissy's Birthstone Ring — variant selection, swipeable gallery, price updates */
(function () {
  'use strict';

  /* ── Variant data from Liquid ── */
  var dataEl = document.getElementById('bs-variant-data');
  var variants = dataEl ? JSON.parse(dataEl.textContent) : [];

  /* ── DOM refs ── */
  var priceDisplay   = document.getElementById('bs-price-display');
  var ctaPrice       = document.getElementById('bs-cta-price');
  var propVariant    = document.getElementById('bs-prop-variant');
  var propPrice      = document.getElementById('bs-prop-price');
  var variantDisplay = document.getElementById('bs-variant-display');
  var thumbContainer = document.getElementById('bs-thumbs');
  var slider         = document.getElementById('bs-slider');
  var mainImage      = document.querySelector('.bs-main-image');

  /* ── Slide state ── */
  var currentIndex = 0;
  var slideCount   = slider ? slider.children.length : 0;

  function getThumbs() { return document.querySelectorAll('.bs-thumb'); }

  function goToSlide(idx) {
    if (idx < 0) idx = 0;
    if (idx >= slideCount) idx = slideCount - 1;
    currentIndex = idx;
    slider.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';
    /* Update thumb active state */
    var thumbs = getThumbs();
    thumbs.forEach(function (t, i) {
      t.classList.toggle('active', i === currentIndex);
    });
  }

  /* ── Touch swipe with drag follow ── */
  if (mainImage && slider) {
    var startX = 0;
    var startY = 0;
    var dragX  = 0;
    var locked = false; /* true once we decide horizontal vs vertical */
    var isHorizontal = false;

    mainImage.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      dragX  = 0;
      locked = false;
      isHorizontal = false;
      slider.classList.add('dragging');
    }, { passive: true });

    mainImage.addEventListener('touchmove', function (e) {
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;

      if (!locked) {
        if (Math.abs(dx) > 8 || Math.abs(dy) > 8) {
          locked = true;
          isHorizontal = Math.abs(dx) > Math.abs(dy);
        }
        return;
      }

      if (!isHorizontal) return;

      e.preventDefault();
      dragX = dx;
      var baseOffset = -(currentIndex * 100);
      var pxToPercent = (dragX / mainImage.offsetWidth) * 100;
      slider.style.transform = 'translateX(' + (baseOffset + pxToPercent) + '%)';
    }, { passive: false });

    mainImage.addEventListener('touchend', function () {
      slider.classList.remove('dragging');
      if (!isHorizontal) return;

      var threshold = mainImage.offsetWidth * 0.2;
      if (dragX < -threshold && currentIndex < slideCount - 1) {
        goToSlide(currentIndex + 1);
      } else if (dragX > threshold && currentIndex > 0) {
        goToSlide(currentIndex - 1);
      } else {
        goToSlide(currentIndex); /* snap back */
      }
      dragX = 0;
    }, { passive: true });
  }

  /* ── Variant selection ── */
  document.querySelectorAll('#bs-variants .bs-variant').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('#bs-variants .bs-variant').forEach(function (b) {
        b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
      });

      var vid   = btn.dataset.variantId;
      var price = btn.dataset.price;
      var name  = btn.dataset.name;

      priceDisplay.textContent   = price;
      ctaPrice.textContent       = price;
      variantDisplay.textContent = name;
      propVariant.value          = name;
      propPrice.value            = price;

      /* Swap to variant featured image if available */
      var match = variants.find(function (v) { return String(v.id) === vid; });
      if (match && match.featured_image) {
        var slides = slider.children;
        for (var i = 0; i < slides.length; i++) {
          var img = slides[i].querySelector('img');
          if (img && img.src.indexOf(match.featured_image.split('?')[0].split('/').pop()) !== -1) {
            goToSlide(i);
            break;
          }
        }
      }
    });
  });

  /* ── Gallery thumbnail navigation ── */
  if (thumbContainer) {
    thumbContainer.addEventListener('click', function (e) {
      var btn = e.target.closest('.bs-thumb');
      if (!btn) return;
      goToSlide(parseInt(btn.dataset.slide, 10));
    });
  }

})();
